var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 819,
    height: 564,
    viewBox: "0 0 819 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.2086 0L20.2086 562.674M98.3577 0L98.3577 562.674M176.507 0L176.507 562.674M938.135 0.325665L0.345703 0.325621M254.656 0L254.656 562.674M938.135 62.845L0.345703 62.845M332.805 0L332.805 562.674M938.135 125.364L0.345703 125.364M410.954 0V562.674M938.135 187.884L0.345703 187.884M489.103 0V562.674M938.135 250.403L0.345703 250.403M567.252 0V562.674M938.135 312.923L0.345703 312.922M645.401 0V562.674M938.135 375.442L0.345703 375.442M840.774 0V562.674M938.135 531.74L0.345703 531.74M723.551 0V562.674M938.135 437.961L0.345703 437.961M918.923 0V562.674M59.2832 0L59.2831 562.674M137.432 0L137.432 562.674M215.581 0L215.581 562.674M938.135 31.5853L0.345703 31.5853M293.73 0L293.73 562.674M938.135 94.1047L0.345703 94.1047M371.88 0V562.674M938.135 156.624L0.345703 156.624M450.029 0V562.674M938.135 219.143L0.345703 219.143M528.178 0V562.674M938.135 281.663L0.345703 281.663M606.327 0V562.674M938.135 344.182L0.345703 344.182M801.7 0V562.674M938.135 500.481L0.345703 500.481M684.476 0V562.674M938.135 406.702L0.345703 406.702M879.849 0V562.674M938.135 563L0.345703 563M762.625 0V562.674M938.135 469.221L0.345703 469.221",
    stroke: "url(#paint0_radial_2093_6903)",
    strokeWidth: 0.651243
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2093_6903",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(469.24 281.337) rotate(90) scale(270.266 270.266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07775D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07775D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.82342b3af2a045f75814baa98e948a19.svg";
export { ForwardRef as ReactComponent };